<template>
	<v-text-field :value="value" :label="label" :suffix="suffix" :disabled="disabled" :min="min" :step="step"
		:class="widthClass" :rules="rules" class="flex-grow-0" type="number" dense outlined hide-spin-buttons
		hide-details="auto" @input="emit($event)"></v-text-field>
</template>

<script>
/**
 * The numeric field the module card uses. Thin on purpose: it keeps the dense/outlined styling in
 * one place, and emits numbers rather than the strings a native number input hands back, so the
 * module object stays numeric however it was edited.
 */
export default {
	name: "NumberField",
	props: {
		value: [Number, String],
		label: String,
		suffix: String,
		disabled: Boolean,
		min: {
			type: Number,
			default: null
		},
		step: {
			type: Number,
			default: 1
		},
		widthClass: {
			type: String,
			default: "w-32"
		},
		rules: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		emit(raw) {
			// an empty field stays empty rather than becoming 0, so a cleared box does not price
			this.$emit("input", raw === "" || raw === null ? "" : Number(raw));
		}
	}
};
</script>
